import TemplateView from '../../../TemplateView'

export default class WelcomeScreenLightboxFooter extends TemplateView
{
    constructor({
        loadExternalWelcomeScreen
    }) {
        super()
        this.params = { loadExternalWelcomeScreen }
    }

    templateHtml() {
        return this.params.loadExternalWelcomeScreen ? '' : `<div></div>`
    }

    getCommitBtnEl() {
        return this.find('.cancelBtn')
    }

    getCancelBtnEl() {
        return this.find('.cancelBtn')
    }
}



// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/components/WelcomeScreenLightboxFooter.js